/** Shared create-issue dialog width — My Tasks, Issues, Sprint Board add-task. */
export const ISSUE_FORM_MODAL_MAX_WIDTH = 680;

export const issueFormModalPanelStyle = {
  background: '#fff',
  borderRadius: 16,
  padding: '1.75rem 2rem',
  width: '100%',
  maxWidth: ISSUE_FORM_MODAL_MAX_WIDTH,
  maxHeight: '90vh',
  overflowY: 'auto',
  boxShadow: '0 25px 60px rgba(0,0,0,0.25)',
};
